import Button from "../../../../../common/components/button";
import TableName from "../../../../components/common/tableName";
import Input from "../../../../components/common/input";
import Toggle from "../../../../components/common/toggle";
import SelectBox from "../../../../components/common/selectBox";
import { useGetWordCategory } from "../../../../../common/hooks/console/management/word/useGetWordCategory";
import { useEffect, useState } from "react";
import { useGetWordInfo } from "../../../../../common/hooks/console/management/word/useGetWordInfo";
import useToastStore from "../../../../store/useToastStore";
import { usePutWord } from "../../../../../common/hooks/console/management/word/usePutWord";
import { useAuthStore } from "../../../../store/useAuthStore";

interface ModifyWordProps {
    idx: number;
    onDelete: (id: number) => void;
}

const ModifyWord = ({ idx, onDelete }: ModifyWordProps) => {
    const { addToast } = useToastStore();
    const level = useAuthStore(state => state.m_level);

    const [selectedCategory, setSelectedCategory] = useState<string>("");
    const [editedWreathWord, setEditedWreathWord] = useState<string>("");
    const [editedSearchWord, setEditedSearchWord] = useState<string>("");
    const [isOn, setIsOn] = useState<boolean>(false);
    const [wreathWordError, setWreathWordError] = useState<boolean>(false);
    const [initialState, setInitialState] = useState({
        category: "",
        wreathWord: "",
        searchWord: "",
        status: false,
    });

    const { data: categoryData } = useGetWordCategory();
    const { data: wordInfo } = useGetWordInfo(idx);
    const { mutate } = usePutWord(() => {
        addToast({
            type: "success",
            message: "해당 경조사어가 변경되었습니다.",
        });
    }, idx?.toString());

    const handleSave = () => {
        if (!editedWreathWord.trim()) {
            setWreathWordError(true);
            return;
        }
        mutate({
            status: isOn,
            event_category_idx: Number(selectedCategory),
            wreath_word: editedWreathWord,
            search_word: editedSearchWord,
        });
    };
    const handleCancel = () => {
        setSelectedCategory(initialState.category);
        setEditedWreathWord(initialState.wreathWord);
        setEditedSearchWord(initialState.searchWord);
        setIsOn(initialState.status);
        setWreathWordError(false);
    };
    const categoryOptions = categoryData
        ? categoryData.map(cat => ({
              value: cat.event_category_idx.toString(),
              label: cat.event_name,
          }))
        : [];

    useEffect(() => {
        if (wordInfo) {
            const categoryId = wordInfo.category.event_category_idx.toString();
            const wreath = wordInfo.wreath_word || "";
            const search = wordInfo.search_word || "";
            const status = wordInfo.status ?? false;
            setSelectedCategory(categoryId);
            setEditedWreathWord(wreath);
            setEditedSearchWord(search);
            setIsOn(status);
            setInitialState({
                category: categoryId,
                wreathWord: wreath,
                searchWord: search,
                status: status,
            });

            setWreathWordError(false);
        }
    }, [wordInfo]);

    return (
        <div className="bg-white gap-5 shadow-custom flex flex-col px-3 py-5 rounded-xl">
            <div>
                <div className="flex items-center justify-between">
                    <p className="text-xl font-bold truncate max-w-[450px]">
                        {wordInfo?.wreath_word}
                        {wordInfo?.search_word && `(${wordInfo.search_word})`}
                    </p>
                    {level !== 7 && level !== 8 && (
                        <Button className="px-2" size="S" status="error" onClick={() => onDelete(idx)}>
                            삭제
                        </Button>
                    )}
                </div>
                <p className="text-sm text-gray2">{wordInfo?.reg_date} 등록</p>
            </div>
            <div className="border-t-2 border-gray2">
                <div className="flex items-center border-b border-gray4">
                    <TableName className="h-12" required>
                        노출여부
                    </TableName>
                    <Toggle
                        disabled={level === 7}
                        onLabel="노출"
                        offLabel="미노출"
                        className="pl-2"
                        isOn={isOn}
                        onToggle={() => setIsOn(!isOn)}
                    />
                </div>
                <div className="flex items-center border-b border-gray4">
                    <TableName className="h-12" required>
                        카테고리
                    </TableName>
                    <SelectBox
                        disabled={level === 7}
                        full
                        className="w-full bg-white px-2"
                        placeholder="카테고리 선택"
                        options={categoryOptions}
                        value={selectedCategory}
                        onChange={value => setSelectedCategory(value)}
                    />
                </div>
                <div className="flex items-center border-b border-gray4">
                    <TableName className="h-12" required>
                        경조사어
                    </TableName>
                    <Input
                        maxLength={30}
                        placeholder="30자"
                        className="w-full px-2"
                        value={editedWreathWord}
                        onChange={e => {
                            setEditedWreathWord(e.target.value);
                            setWreathWordError(false);
                        }}
                        status={wreathWordError ? "error" : level === 7 ? "view" : undefined}
                    />
                </div>
                <div className="flex items-center border-b border-gray4">
                    <TableName className="h-12">검색어</TableName>
                    <Input
                        maxLength={30}
                        placeholder="30자"
                        className="w-full px-2"
                        value={editedSearchWord}
                        status={level === 7 ? "view" : undefined}
                        onChange={e => setEditedSearchWord(e.target.value)}
                    />
                </div>
            </div>
            {level !== 7 && (
                <div className="flex w-full gap-2">
                    <Button className="w-full" size="L" onClick={handleCancel}>
                        취소
                    </Button>
                    <Button status="regist" className="w-full" size="L" onClick={handleSave}>
                        저장
                    </Button>
                </div>
            )}
        </div>
    );
};

export default ModifyWord;
